<div class="row justify-content-center">
  <div class="col-lg-10">
      <div class="card">
          <div class="card-header bg-info">
              <h4 class="m-b-0 text-white">{{editingId ? 'Actualizar grupo' : 'Crear grupo de pruebas'}}</h4>
          </div>
          <div class="card-body">

            <div>
              <div class="form-body">
                  <div class="row">
                      
                    <div class="form-group form-material col-md-6">
                      <input [(ngModel)]="group.title" type="text" class="form-control" placeholder="Nombre">
                      <span class="help-block text-muted"><small>Nombre del grupo/categoría</small></span>
                    </div>
                    
                    <div *ngIf="user.role == 'admin'" class="form-group form-material col-md-6">
                      <input [(ngModel)]="group.description" type="text" class="form-control" placeholder="Descripción">
                      <span class="help-block text-muted"><small>Descripción</small></span>
                    </div>

                    <div *ngIf="user.role == 'admin'" class="form-group form-material col-md-6">
                      <input [(ngModel)]="group.testsQuantity" type="number" class="form-control" placeholder="Cantidad de pruebas">
                      <span class="help-block text-muted"><small>Cantidad de pruebas</small></span>
                    </div>

                    <div *ngIf="user.role == 'admin'" class="form-group form-material col-md-6">
                      <input [(ngModel)]="group.questionsQuantity" type="number" class="form-control" placeholder="Cantidad de preguntas">
                      <span class="help-block text-muted"><small>Cantidad de preguntas</small></span>
                    </div>



                    <div *ngIf="user.role == 'admin'" class="col-12 mb-5">

                      <div class="row">

                        <div class="col-12 mb-5">
                          <span >Información</span>
                          <div id="toolbar"></div>
                          <div class="info-editor"></div>

                        </div>
                      </div>

                    </div>


                    
                  </div>

                  
              </div>
              <div class="form-actions">
                  <button type="button" class="btn btn-info btn-rounded mt-3" (click)="create()" > {{editingId ? 'Actualizar' : 'Guardar'}}</button>
              </div>
            </div>


          </div>
      </div>
  </div>
</div>